import { ResponsiveProp, Width } from "../../../../../types";
import { MaxWidth } from "../../types";

export const MAX_WIDTH_MAP: { [key in MaxWidth]: ResponsiveProp<Width> } = {
  large: ["100%", "900px"],
  medium: ["100%", "640px"],
  small: ["100%", "500px"]
};
